import { useEffect, useState } from 'react';

const DeliveryOptions = ({
  truckType,
  setTruckType,
  truckTypeList,
  cargoInsurance,
  setCargoInsurance,
  additionalInfoRef,
  additionalInfo,
  setAdditionalInfo,
  setIsScheduled,
  isScheduled,
  scheduledPickupTime,
  setScheduledPickupTime,
}) => {
  const [minDateTime, setMinDateTime] = useState('');

  const updateMinDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    setMinDateTime(formattedDateTime);
  };

  useEffect(() => {
    updateMinDateTime();
    const interval = setInterval(updateMinDateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    adjustTextareaHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalInfo]);

  const adjustTextareaHeight = () => {
    if (additionalInfoRef.current) {
      additionalInfoRef.current.style.height = 'auto';
      additionalInfoRef.current.style.height = `${additionalInfoRef.current.scrollHeight}px`;
    }
  };
  return (
    <>
      <div className="form-row mb-1">
        <label className="col-sm-3 col-form-label">Truck Type:</label>
        <div className="col-sm-9">
          <select
            className="custom-select"
            value={truckType}
            onChange={(e) => setTruckType(e.target.value)}
          >
            <option value="">Select Truck Type</option>
            {truckTypeList &&
              truckTypeList.map((truck) => (
                <option key={truck.id} value={truck.id}>
                  {truck.title}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div className="form-row mb-2">
        <label className="col-sm-3 col-form-label">Cargo Insurance:</label>
        <div className="col-sm-9">
          <select
            className="custom-select"
            value={cargoInsurance}
            onChange={(e) => setCargoInsurance(e.target.value)}
          >
            <option>Select Cargo Insurance</option>
            <option value="1">$0 - $499</option>
            <option value="2">$500 - $999</option>
            <option value="3">$1000 - $1999</option>
            <option value="4">$2000 - $2999</option>
            <option value="5">$3000 - $5000</option>
            <option value="6">N/A</option>
          </select>
        </div>
      </div>
      <textarea
        ref={additionalInfoRef}
        value={additionalInfo}
        className="form-control"
        name="add_info"
        onChange={(e) => {
          setAdditionalInfo(e.target.value);
          adjustTextareaHeight();
        }}
        placeholder="Additional Info"
        rows={1}
      />

      <div className="form-group form-check mt-3">
        <input
          type="checkbox"
          className="form-check-input"
          id="scheduledPickupCheckbox"
          checked={isScheduled}
          onChange={(e) => setIsScheduled(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="scheduledPickupCheckbox">
          Schedule Delivery
        </label>
      </div>

      {isScheduled && (
        <div className="form-group">
          <label htmlFor="scheduledPickupTime">Scheduled Delivery Time:</label>
          <input
            type="datetime-local"
            className="form-control"
            id="scheduledPickupTime"
            value={scheduledPickupTime}
            onChange={(e) => setScheduledPickupTime(e.target.value)}
            min={minDateTime} // Ensures the time is not in the past
            required
          />
        </div>
      )}
    </>
  );
};

export default DeliveryOptions;
